import styled from 'styled-components';
import { ColorConstants } from '@shared/constants';
import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
    tooltipStyleWrapper: {
        background: `${ColorConstants.white} 0% 0% no-repeat padding-box !important`,
        boxShadow: `0px 0px 10px ${ColorConstants.grey} !important`,
        color: `${ColorConstants['regal-blue']} !important`,
        fontFamily: 'Helvetica, sans-serif !important',
        fontSize: '13px !important',
    },
    tooltipStyleArrow: {
        color: ColorConstants.white,
    },
});

export const CampaignRemovedIcon = styled.img`
    width: 16px;
    height: 16px;
`;
